import alchemist from "./alchemist.png";
import amberclad from "./amberclad.png";
import amberedIrons from "./amberedIrons.jpg";
import airship from "./airship.png";
import anchored from "./anchored.png";
import ardent from "./ardent.png";
import armaments from "./armaments.png";
import attackRoll from "./attackRoll.png";
import bloodmawHunters from "./bloodmawHunters.png";
import carcharbora from "./carcharbora.png";
import celebration from "./celebration.jpg";
import char from "./char.png";
import characterSheet from "./characterSheet.png";
import charts from "./charts.png";
import chase from "./chase.png";
import chatting from "./chatting.png";
import companion from "./companion.png";
import concoct from "./concoct.png";
import corron from "./corron.png";
import corron2 from "./corron-2.png";
import corsair from "./corsair.png";
import crash from "./crash.png";
import crawl from "./crawl.png";
import crawler from "./crawler.png";
import dawhehWhe from "./dawhehWheh.png";
import dawhehWhe2 from "./dawhehWheh2.png";
import design from "./design.png";
import dredger from "./dredger.png";
import drives from "./drives.png";
import ektus from "./ektus.png";
import food from "./food.png";
import foxloft from "./foxloft.jpg";
import gangs from "./gangs.png";
import gau from "./gau.png";
import hacker from "./hacker.png";
import hazards from "./hazards.jpg";
import horizoneer from "./horizoneer.png";
import hunter from "./hunter.png";
import icterine from "./icterine.jpg";
import impact from "./impact.jpg";
import itzenko from "./itzenko.png";
import itzenko2 from "./itzenko2.png";
import interregnum from "./interregnum.jpg";
import ironbound from "./ironbound.png";
import ironjawRays from "./ironjawRays.png";
import ironroots from "./ironroots.png";
import ketra from "./ketra.png";
import kremichSurge from "./kremichSurge.jpg";
import languages from "./languages.png";
import lantern from "./lantern.png";
import lionsMane from "./lionsMane.png";
import lore from "./lore.png";
import madWoodcutter from "./madWoodcutter.png";
import manticrows from "./manticrows.png";
import mantidDrake from "./mantidDrake.png";
import marauders from "./marauders.png";
import mesmer from "./mesmer.png";
import monster from "./monster.png";
import mothryn from "./mothryn.png";
import mothryn2 from "./mothryn2.png";
import navigator from "./navigator.png";
import navigator2 from "./navigator2.png";
import octodew from "./octodew.png";
import octopus from "./octopus.png";
import oldOrnail from "./oldOrnail.png";
import orchidScar from "./orchidScar.png";
import outrider from "./outrider.png";
import pangoska from "./pangoska.png";
import petrou from "./petrou.png";
import pinwolf from "./pinwolf.png";
import queenBeneath from "./queenBeneath.png";
import range from "./range.png";
import rating from "./rating.png";
import rattlehand from "./rattlehand.png";
import relax from "./relax.png";
import resources from "./resources.png";
import ridgeback from "./ridgeback.png";
import rootless from "./rootless.png";
import saws from "./saws.png";
import screw from "./screw.png";
import scrutiny from "./scrutiny.jpg";
import shankling from "./shankling.png";
import ship from "./ship.png";
import ship2 from "./ship2.png";
import ship3 from "./ship3.png";
import ship4 from "./ship4.png";
import shipbuilding from "./shipbuilding.jpg";
import shipgarden from "./shipgarden.png";
import shipSheet from "./shipSheet.png";
import slinger from "./slinger.png";
import slinger2 from "./slinger2.png";
import slinger3 from "./slinger3.png";
import snapperpillars from "./snapperpillars.png";
import species from "./species.png";
import spectrapedes from "./spectrapedes.png";
import spielographer from "./spielographer.png";
import spirituality from "./spirituality.png";
import spitBorn from "./spitBorn.png";
import steep from "./steep.png";
import submersible from "./submersible.png";
import submersible2 from "./submersible2.png";
import submersible3 from "./submersible3.png";
import surgeon from "./surgeon.png";
import tempest from "./tempest.png";
import terminology from "./terminology.jpg";
import terrapex from "./terrapex.png";
import tracks from "./tracks.png";
import travel from "./travel.png";
import tryphoradons from "./tryphoradons.png";
import tzelicrae from "./tzelicrae.png";
import watch from "./watch.png";
import whitecollarSnare from "./whitecollarSnare.png";
import wildsailor from "./wildsailor.png";
import winterJackets from "./winterJackets.png";
import wordbearer from "./wordbearer.png";
import wretchbeaks from "./wretchbeaks.png";
import prophetsFall from "./prophetsFall.jpg";
import mires from "./mires.jpg";
import watchfulEyes from "./watchfulEyes.png";
import float from "./float.png";
import glide from "./glide.png";
import stunt2 from "./stunt2.png";
import crashLanding from "./crashLanding.png";
import landing from "./landing.png";
import drift from "./drift.png";
import flap from "./flap.png";
import pressure from "./pressure.png";
import delve from "./delve.png";
import shell from "./shell.png";
import kosmer from "./kosmer.png";
import heartskavo from "./heartskavo.png";
import stowaway from "./stowaway.png";
import submerged from "./submerged.png";
import windward from "./windward.png";
import augur from "./augur.png";
import cannoneer from "./cannoneer.png";
import diver from "./diver.png";
import kitesailor from "./kitesailor.png";
import marketeer from "./marketeer.png";
import pilot from "./pilot.png";
import rattlewing from "./rattlewing.png";
import raveller from "./raveller.png";
import smuggler from "./smuggler.png";
import swarmjack from "./swarmjack.png";
import thorn from "./thorn.png";
import zealot from "./zealot.png";
import augmentor from "./augmentor.png";
import agronaut from './agronaut.png';

export const BLOODLINE_COMPENDIUM_IMAGES = [
  ardent,
  ektus,
  gau,
  ironbound,
  ketra,
  mothryn,
  tzelicrae,
]

export const ORIGIN_COMPENDIUM_IMAGES = [
  amberclad,
  anchored,
  ridgeback,
  rootless,
  shankling,
  spitBorn,
]

export const POST_COMPENDIUM_IMAGES = [
  alchemist,
  char,
  corsair,
  crash,
  dredger,
  hacker,
  horizoneer,
  hunter,
  mesmer,
  navigator,
  rattlehand,
  screw,
  slinger,
  steep,
  surgeon,
  tempest,
  wordbearer,
]

export {
  augur,
  augmentor,
  cannoneer,
  diver,
  kitesailor,
  marketeer,
  pilot,
  rattlewing,
  raveller,
  smuggler,
  swarmjack,
  thorn,
  zealot,
  kosmer,
  heartskavo,
  stowaway,
  submerged,
  windward,
  watchfulEyes,
  float,
  glide,
  stunt2,
  crashLanding,
  landing,
  drift,
  flap,
  pressure,
  delve,
  shell,
  alchemist,
  amberclad,
  amberedIrons,
  anchored,
  airship,
  ardent,
  armaments,
  attackRoll,
  bloodmawHunters,
  celebration,
  carcharbora,
  char,
  characterSheet,
  charts,
  chase,
  chatting,
  companion,
  concoct,
  corron,
  corron2,
  corsair,
  crash,
  crawl,
  crawler,
  dawhehWhe,
  dawhehWhe2,
  design,
  dredger,
  drives,
  ektus,
  food,
  foxloft,
  gangs,
  gau,
  hacker,
  hazards,
  horizoneer,
  hunter,
  icterine,
  impact,
  interregnum,
  ironbound,
  ironjawRays,
  ironroots,
  itzenko,
  itzenko2,
  ketra,
  kremichSurge,
  languages,
  lantern,
  lionsMane,
  lore,
  madWoodcutter,
  manticrows,
  mantidDrake,
  marauders,
  mesmer,
  mires,
  monster,
  mothryn,
  mothryn2,
  navigator,
  navigator2,
  octodew,
  octopus,
  oldOrnail,
  orchidScar,
  outrider,
  pangoska,
  petrou,
  pinwolf,
  prophetsFall,
  queenBeneath,
  range,
  rating,
  rattlehand,
  relax,
  resources,
  ridgeback,
  rootless,
  saws,
  screw,
  scrutiny,
  shankling,
  ship,
  ship2,
  ship3,
  ship4,
  shipbuilding,
  shipgarden,
  shipSheet,
  slinger,
  slinger2,
  slinger3,
  snapperpillars,
  species,
  spectrapedes,
  spielographer,
  spirituality,
  spitBorn,
  steep,
  submersible,
  submersible2,
  submersible3,
  surgeon,
  tempest,
  terminology,
  terrapex,
  tracks,
  travel,
  tryphoradons,
  tzelicrae,
  watch,
  whitecollarSnare,
  wildsailor,
  winterJackets,
  wordbearer,
  wretchbeaks,
  agronaut,
};
